import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DraftDocumentActions from './DraftDocumentActions';
import { formatSource } from '../../../utils/helper';
import { currencyFormatter } from '../../../utils/currencyFormat';
import CustomPagination from '../../../components/customPagination';
import { useGetDebitNotesHandler } from '../../debitNotes/dataHandlers/getDebitNotesHandler';

const SBDraftsDebitNotesTable = ({ handlePaginationChange, searchQuery }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { debitNotes, totalDocuments, isLoading } = useGetDebitNotesHandler({ searchQuery });

  const columns = [
    {
      field: 'document_number',
      headerName: 'Debit Note No',
      flex: 1,
      renderCell: ({ row }) => (
        <Typography
          variant="body1"
          sx={{
            textDecoration: 'underline',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            pl: '0.7rem',
          }}
          onClick={() => navigate(`/self-billed-drafts/debit-notes/${row.document_id}`)}
        >
          {row.document_number}
        </Typography>
      ),
    },
    {
      field: 'document_date',
      headerName: 'Submission Date',
      flex: 1,
    },
    {
      field: 'source',
      headerName: 'Submission channel',
      flex: 1,
      valueFormatter: (params) => formatSource(params),
    },
    {
      field: 'total_tax_amount',
      headerName: 'Tax',
      flex: 0.5,
      renderCell: ({ row }) =>
        row.document_currency_code === 'MYR'
          ? `RM ${currencyFormatter().format(row.total_tax_amount)}`
          : currencyFormatter(row.document_currency_code).format(row.total_tax_amount),
    },
    {
      field: 'total_payable_amount',
      headerName: 'Total',
      flex: 1,
      renderCell: ({ row }) =>
        row.document_currency_code === 'MYR'
          ? `RM ${currencyFormatter().format(row.grand_total)}`
          : currencyFormatter(row.document_currency_code).format(row.grand_total),
    },
    {
      field: 'row',
      headerName: 'Actions',
      flex: 0.3,
      sortable: false,
      renderCell: ({ row }) => (
        <DraftDocumentActions
          handleDetailsClickAction={() => navigate(`/self-billed-drafts/debit-notes/${row.document_id}`)}
          docType="debit-notes"
          row={row}
        />
      ),
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={debitNotes}
        columns={columns}
        getRowId={(row) => row._id}
        paginationMode="server"
        rowCount={totalDocuments}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page + 1, model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default SBDraftsDebitNotesTable;
